<template>
   <div :id="id" class="echarts"></div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import * as echarts from 'echarts';
import { usePdftStore } from '@/store/pdf'
export default {
    name: 'echarts',
    props:{
        name:{
            type:String,
            default:() => null
        },
        type:{
            type:String,
            default:() => null
        }
    },
    setup(props) {
        const data = reactive({
            id:props.name,
            type:props.type
        })
        //引入数据管理库
        const PdftStore = usePdftStore()
        
        const chartOption = (data) => {
            const myChart = echarts.init(document.getElementById(data.id))
            myChart.setOption({
                title: {
                    subtext:`${PdftStore.fromData.questionnaireInfo?.top}%`,
                    text: `TOP`,
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        color: '#333',
                        fontWeight: 'normal',
                        fontSize: 14,
                    },
                    subtextStyle:{
                        color: '#333',
                        fontWeight: 'bold',
                        fontSize: 24,
                    }
                },
                color: ['#00baf4'],
                legend: {},
                radar: [
                    {
                        indicator: [
                            { name: '运营排放' ,type:'a',color:data.type == 'a' ? '#00bef5' : '#544a48'},
                            { name: '产业链排放' ,type:'b',color:data.type == 'b' ? '#00bef5' : '#544a48'},
                            { name: '直接减排贡献' ,type:'c',color:data.type == 'c' ? '#00bef5' : '#544a48'},
                            { name: '间接减排贡献' ,type:'d',color:data.type == 'd' ? '#00bef5' : '#544a48'},
                            { name: '零碳运营' ,type:'e',color:data.type == 'e' ? '#00bef5' : '#544a48'},
                            { name: '绿色供应链' ,type:'f',color:data.type == 'f' ? '#00bef5' : '#544a48'},
                            { name: '承诺与披露' ,type:'g',color:data.type == 'g' ? '#00bef5' : '#544a48'},
                            { name: '零碳投资' ,type:'h',color:data.type == 'h' ? '#00bef5' : '#544a48'},
                        ],
                        center: ['50%', '50%'],
                        radius: 120,
                        startAngle: 90,
                        splitNumber: 5,
                        shape: 'circle',
                        axisName: {
                            formatter: function (value,indicator) {
                                return '{'+indicator.type+'|}\n'+ value;
                            },
                            lineHeight:24,
                            color: '#544a48',
                            rich:{
                                a:{
                                    backgroundColor: {
                                        image:data.type == 'a' ? require('@/assets/img/echartsa_2.png') : require('@/assets/img/echartsa_1.png')
                                    },
                                    width:22,
                                    height: 31,
                                },
                                b:{
                                    backgroundColor: {
                                        image: data.type == 'b' ? require('@/assets/img/echartsb_2.png') : require('@/assets/img/echartsb_1.png')
                                    },
                                    width:34,
                                    height: 20
                                },
                                c:{
                                    backgroundColor: {
                                        image: data.type == 'c' ? require('@/assets/img/echartsc_2.png') : require('@/assets/img/echartsc_1.png')
                                    },
                                    width:21,
                                    height: 32
                                },
                                d:{
                                    backgroundColor: {
                                        image: data.type == 'd' ? require('@/assets/img/echartsd_2.png') :  require('@/assets/img/echartsd_1.png')
                                    },
                                    width:29,
                                    height: 33
                                },
                                e:{
                                    backgroundColor: {
                                        image: data.type == 'e' ? require('@/assets/img/echartse_2.png') : require('@/assets/img/echartse_1.png')
                                    },
                                    width:28,
                                    height: 28
                                },
                                f:{
                                    backgroundColor: {
                                        image: data.type == 'f' ? require('@/assets/img/echartsf_2.png') : require('@/assets/img/echartsf_1.png')
                                    },
                                    width:28,
                                    height: 28
                                },
                                g:{
                                    backgroundColor: {
                                        image: data.type == 'g' ? require('@/assets/img/echartsg_2.png') : require('@/assets/img/echartsg_1.png')
                                    },
                                    width:28,
                                    height: 31
                                },
                                h:{
                                    backgroundColor: {
                                        image: data.type == 'h' ? require('@/assets/img/echartsh_2.png') : require('@/assets/img/echartsh_1.png')
                                    },
                                    width:28,
                                    height: 32
                                },
                            }
                        },
                    },
                ],
                series: [
                    {
                        type: 'radar',
                        center: ['50%', '50%'],
                        emphasis: {
                            lineStyle: {
                                width: 4
                            }
                        },
                        data: [
                            {
                                value: PdftStore.fromData.scoreList,
                                areaStyle: {
                                    color: 'rgba(154, 234, 253, 0.6)'
                                }
                            },
                        ]
                    },
                ]
            },true)
        }
        
        onBeforeMount(() => {})
        onMounted(() => {
            chartOption(data)
        })
        return {
            PdftStore,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.echarts{
    width: 100%;
    height: 100%;
}
</style>